import React, { Component } from 'react';
import { Icon, Toast } from 'antd-mobile';
import { Link } from 'react-router-dom';
import styles from './index.module.less';
import SendVRCode from '../personageEnroll/components';
import { getcompany } from '../../service/chat-service';
import iconapp from '../../public/images/appiocn.png';
/**
 * 企业注册
 */
export class personageEnroll extends Component {
  constructor(props) {
    super(props);

    const staffUserId = window.location.search.match(/staffUserId=([^&]*)/)[1];
    const companyCode = window.location.search.match(/companyCode=([^&]*)/)[1];

    this.state = {
      realName: '', // 姓名
      phone: '', // 手机号
      VRCode: '', // 验证码
      password: '', // 密码
      repassword: '', // 二次密码
      companyName: '', // 公司名称
      staffUserId, // 员工邀请，员工id
      companyCode, // 企业邀请,员工id
      bgs: false, // 登录注册提示框
      changg: 0, // 成功失败提示语切换
      // codetype: 0,
      major: '', // 职务
      register: 'REGISTERED', // 是否已注册
    };
  }

  componentDidMount() {
    window.document.title = '企业注册';
  }

  // 输入信息
  handleChange = (key) => (event) => {
    const { value } = event.target;
    this.setState({ [key]: value });
  };

  // 注册登陆
  login = () => {
    const {
      realName,
      phone,
      VRCode,
      password,
      repassword,
      companyName,
      staffUserId,
      companyCode,
      major,
      register,
    } = this.state;
    if (realName === '') {
      return Toast.show('请输入姓名');
    }
    if (phone.length < 11) {
      return Toast.show('请检查手机号输入');
    }
    if (VRCode.length === 0) {
      return Toast.show('验证码为空');
    }
    if (register === 'NO_REGISTER' && companyName === '') {
      return Toast.show('公司名称为空');
    }
    if (register === 'NO_REGISTER' && major === '') return Toast.show('请输入你的职务');
    if (register === 'NO_REGISTER' && major.length > 11) return Toast.show('职务不能超过11位');

    if (register === 'NO_REGISTER' && password.length < 8) {
      return Toast.show('密码小于8位');
    }
    if (register === 'NO_REGISTER' && repassword !== password) {
      return Toast.show('两次密码不一致!');
    }

    const option = {
      realName,
      password,
      repassword,
      phone,
      companyName,
      staffUserId,
      companyCode,
      ycode: VRCode,
      major,

    };
    getcompany(option).then((res) => {
      const { code, message } = res;
      if (code !== 10000) {
        Toast.info(message, 1);
      } else if (code === 20000 && message === '账号已注册，请登录') {
        this.setState({ bgs: true, changg: 1 });
      } else if (register === 'NO_REGISTER' && code === 10000) {
        this.setState({ bgs: true, changg: 1 });
      } else if (register === 'REGISTERED' && code === 10000)Toast.info('绑定成功', 1);
    });
    return true;
  };

  close = (e) => {
    if (e.target && e.target.matches('a')) {
      // console.log(e);
    } else {
      this.setState({
        bgs: false,
      });
    }
  };

  scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  };

  // 成功失败弹窗
  bg = () => {
    const { changg } = this.state;
    return (
      <div className={styles.beijingtu} onClick={this.close.bind(null)} role="button" tabIndex={0}>
        <div className={styles.bgbox}>
          <div className={styles.bgbox1}>
            {changg ? (
              <span>
                <Icon type="check" className={styles.duigou} size="lg" />
              </span>
            ) : (
              <span className={styles.bgbox1Span}>
                <Icon type="cross" className={styles.duigou} size="lg" />
              </span>
            )}
          </div>
          <div className={styles.bgbox2}>
            {changg === 1 ? <b>恭喜你注册成功</b> : <b>注册失败</b>}
          </div>
          <div className={styles.bgbox3}>
            {changg === 1 ? (
              <span>
                您的审核已提交，请注意查收短信！审核通过后，请登录
                <a
                  className={styles.Asiz}
                  href="http://www.yunkecn.com/pc/home/login"
                  target="view_window"
                >
                  www.yunkecn.com
                </a>
                网站进行体验。
              </span>
            ) : (
              <span>
                您的手机号已存在，请前往
                <a
                  className={styles.Asiz}
                  href="http://www.yunkecn.com/pc/home/login"
                  target="view_window"
                >
                  www.yunkecn.com
                </a>
                网址进行登录。
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  // 验证码
  code = (code, message, data) => {
    if (code === 20000 && message === '账号已注册，请登录') {
      this.setState({ bgs: true, changg: 0 });
    } else if (code === 10000) {
      this.setState({ register: data });
    } else {
      Toast.info(message, 1);
    }
  };

renderDome=() => (
  <div>
    <div className={styles.divs}>
      <input
        type="text"
        onBlur={this.scrollPosition}
        placeholder="请输入公司名称"
        onChange={this.handleChange('companyName')}
      />
    </div>
    <div className={styles.divs}>
      <input
        type="text"
        onBlur={this.scrollPosition}
        placeholder="请输入你的职务"
        onChange={this.handleChange('major')}
      />
    </div>
    <div className={styles.divs}>
      <input
        type="password"
        placeholder="密码必须为8位以上字母+数字组合"
        maxLength="12"
        onBlur={this.scrollPosition}
        onChange={this.handleChange('password')}
      />
    </div>
    <div className={styles.divs}>
      <input
        type="password"
        placeholder="请再次输入密码"
        onBlur={this.scrollPosition}
        onChange={this.handleChange('repassword')}
      />
    </div>
  </div>
)

render() {
  const { phone, bgs, register } = this.state;
  return (
    <div className={styles.box}>
      <div className={styles.con}>
        <div className={styles.imgtop}>
          <img src={iconapp} alt="" />
        </div>
        <div className={styles.conent}>
          <div className={styles.divs}>
            <input
              type="text"
              placeholder="请输入姓名"
              onBlur={this.scrollPosition}
              onChange={this.handleChange('realName')}
            />
          </div>
          <div className={styles.divs}>
            <input
              type="text"
              placeholder="请输入手机号"
              maxLength="11"
              onBlur={this.scrollPosition}
              onChange={this.handleChange('phone')}
            />
          </div>
          <div className={styles.divborder}>
            <input
              type="text"
              placeholder="请输入验证码"
              maxLength="6"
              onBlur={this.scrollPosition}
              onChange={this.handleChange('VRCode')}
            />
            <div className={styles.right}>
              <SendVRCode
                onClick={this.code}
                className={styles.sendCode}
                phoneNumber={phone || undefined}
              />
            </div>
          </div>
          {
              register === 'NO_REGISTER' ? this.renderDome() : null
            }
          <div className={styles.yundu}>
            <span>已阅读并同意以下协议</span>
            <span className={styles.lan}>
              <Link
                style={{ marginLeft: '10px' }}
                to="/agreement"
                className={styles.lan}
              >
                趣销销用户协议

              </Link>
              <Link
                style={{ marginLeft: '10px' }}
                to="/privacy"
                className={styles.lan}
              >
                趣销销隐私协议

              </Link>
            </span>
          </div>
          <div className={styles.landing} onClick={this.login} role="button" tabIndex={0}>
            {
                register === 'NO_REGISTER' ? '同意协议并注册' : '同意协议并绑定'
              }
          </div>
        </div>
      </div>
      {bgs ? this.bg() : ''}
    </div>
  );
}
}

export default personageEnroll;
